import { render, staticRenderFns } from "./attack.vue?vue&type=template&id=051de801&scoped=true&"
import script from "./attack.vue?vue&type=script&lang=js&"
export * from "./attack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051de801",
  null
  
)

export default component.exports